// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>
// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import './vanila/pesquisa_geral';
import { createApp } from 'vue';
import './vanila/notificacao'
import './vanila/degustacao/modal';
import '../src/vanila/menus-mais-acessados/';
import '../src/vanila/utils';
window.createVueApp = createApp;

window.importModule=(pathComp)=>{
  import(/* @vite-ignore */ pathComp);
}
